export const HOMEPAGE = "/";
export const SIGNUPPAGE = "/auth/signup";
export const LOGINPAGE = "/auth/login";
export const USERPAGE = "/user/:userid";
export const EXCHANGEACCOUNT = "/accounts";
export const DASHBOARD = "/dashboard";
export const ORDERDETAIL = "/orders/:orderId";
export const TRADEDETAIL = "/trades/:tradeId";
export const NFTEXPLORER = "/nftexplorer"
export const CHAINBALANCES = "/chainbalances"
export const ERROR404 = "*"

